module.exports = __webpack_public_path__ + "static/media/background-web.de44f92e.svg";